import { useState, useEffect } from "react";
import { IoHome } from "react-icons/io5";
import { FaHeart, FaShoppingCart, FaUser } from "react-icons/fa";
import { MdOutlineBarChart } from "react-icons/md";
import { useNavigate, useLocation } from "react-router-dom";

export default function TopFooter() {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("home");

  useEffect(() => {
    const path = location.pathname;
    if (path === "/") setActiveTab("home");
    else if (path === "/wishlist") setActiveTab("wishlist");
    else if (path === "/all-cart-product") setActiveTab("cart");
    else if (path === "/comparision") setActiveTab("compare");
    else if (path === "/profile") setActiveTab("profile");
  }, [location.pathname]);

  const handleTabClick = (tab, path) => {
    setActiveTab(tab);
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden">
      <nav className="flex justify-between items-center bg-[#550305] text-white px-2 py-3 shadow-lg">
        <button
          onClick={() => handleTabClick("home", "/")}
          className={`flex flex-col items-center justify-center w-1/5 ${
            activeTab === "home" ? "text-red-400" : "text-white"
          }`}
        >
          <IoHome size={20} />
          <span className="text-xs mt-1">Home</span>
        </button>

        <button
          onClick={() => handleTabClick("wishlist", "/wishlist")}
          className={`flex flex-col items-center justify-center w-1/5 ${
            activeTab === "wishlist" ? "text-red-400" : "text-white"
          }`}
        >
          <FaHeart size={20} />
          <span className="text-xs mt-1">Wishlist</span>
        </button>

        <button
          onClick={() => handleTabClick("cart", "/all-cart-product")}
          className={`flex flex-col items-center justify-center w-1/5 ${
            activeTab === "cart" ? "text-red-400" : "text-white"
          }`}
        >
          <FaShoppingCart size={20} />
          <span className="text-xs mt-1">Cart</span>
        </button>

        <button
          onClick={() => handleTabClick("compare", "/comparision")}
          className={`flex flex-col items-center justify-center w-1/5 ${
            activeTab === "compare" ? "text-red-400" : "text-white"
          }`}
        >
          <MdOutlineBarChart size={20} />
          <span className="text-xs mt-1">Compare</span>
        </button>

        <button
          onClick={() => handleTabClick("profile", "/profile")}
          className={`flex flex-col items-center justify-center w-1/5 ${
            activeTab === "profile" ? "text-red-400" : "text-white"
          }`}
        >
          <FaUser size={20} />
          <span className="text-xs mt-1">Profile</span>
        </button>
      </nav>
    </div>
  );
}
